import CalendarObject from "./calendar";
// import Litepicker from "../litepicker";
import Notify from "../notify";

export default class CreateObject {
    constructor() {
        this.settings = {
            calendarId: "object-create-calendar"
        }

        this.initCallendar();

    }

    initCallendar() {


        if ($("#" + this.settings.calendarId).length) {
            const calendar = new CalendarObject(this.settings.calendarId);
            calendar.init();
        }

    }

}

(function() {

    const object = new CreateObject();



})(jQuery);